export function event_array_to_object(raw, device_id) {
    return {
        device_id,
        time: raw[1],
        event_id: `${raw[2]}-${raw[1]}`,
        event_name: raw[2],
        duration: raw[5],
        important: raw[7],
        unread: true,
        gps: raw[3] != null ? { x: raw[3], y: raw[4] } : null,
        data: raw[6],
    };
}
